import { ChangeType } from './change-type.enum'
import { ChangeItemType } from './change-item-type.enum'
import { DiffResult } from '../util/get-item-changes.util'

export class ChangeItemShared {
  changeType: ChangeType
  type: ChangeItemType
  identity?: number
  parentId?: number
  uuid?: string
  data?: any | DiffResult<any>
}

export class ChangeItem extends ChangeItemShared {
  id: number
}
